<template>
    <v-flex xs12 class="social">
        <ul
            class="juicer-feed"
            data-feed-id="ypoglobal-f2ca3458-a19f-4559-994f-2f9c4a65d30e"
            data-columns="3"
            data-truncate="150"
            data-interval="1000"></ul>
    </v-flex>
</template>

<script>
    export default {
        name: "SocialPage",
        components: {},
        mounted() {
                const plugin = document.createElement("script");
                plugin.setAttribute("src", "https://assets.juicer.io/embed.js");
                plugin.async = true;
                document.head.appendChild(plugin);

                const cssplugin = document.createElement("link");
                cssplugin.setAttribute("href", "https://assets.juicer.io/embed.css");
                cssplugin.setAttribute("rel", "stylesheet");
                cssplugin.async = true;
                document.head.appendChild(cssplugin);
        },
        data: () => ({}),
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";

    .referral {
        opacity: 0;
        display: none !important;
    }

    .juicer-ad {
        display: none !important;
    }
</style>
